export enum ResourceType {
    Map = "Map",
    Layer = "Layer",
    MapObject = "MapObject",
    Schedule = "Schedule",
    ScheduleVersion = "ScheduleVersion",
    EventBlock = "EventBlock",
    VenueLocation = "VenueLocation"
}